import { formatCost, formatPct, formatTokens } from '@lens/lib/decode'
import type { ModelCostBreakdown } from '@lens/types/claude'
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts'
import { CHART_TOOLTIP_STYLE } from '../chart-primitives'

interface Props {
 models: ModelCostBreakdown[]
 totalSavings: number
}

export function CacheEfficiencyPanel({ models, totalSavings }: Props) {
 const totalCacheRead = models.reduce((s, m) => s + m.cache_read_tokens, 0)
 const totalInput = models.reduce((s, m) => s + m.input_tokens, 0)
 const totalContext = totalInput + totalCacheRead
 const totalCost = models.reduce((s, m) => s + m.estimated_cost, 0)
 const wouldHavePaid = totalCost + totalSavings

 const pieData = [
 { name: 'Cache Read', value: totalCacheRead, color: 'var(--chart-1)' },
 { name: 'Direct Input', value: totalInput, color: 'var(--chart-2)' },
 ]

 return (
 <div className="grid grid-cols-1 @md/page:grid-cols-[1fr_160px] gap-4 items-start">
 <div className="space-y-2 type-body">
 <div className="flex items-center justify-between">
 <span className="text-foreground">Cache hit rate</span>
 <span className="text-[var(--chart-1)] type-body">{formatPct(totalCacheRead, totalContext)}</span>
 </div>
 <div className="flex items-center justify-between">
 <span className="text-foreground">Context from cache</span>
 <span className="text-foreground ">{formatTokens(totalCacheRead)}</span>
 </div>
 <div className="flex items-center justify-between">
 <span className="text-foreground">Context from input</span>
 <span className="text-foreground ">{formatTokens(totalInput)}</span>
 </div>
 <div className="border-t border-border/50 pt-2 mt-2 space-y-1.5">
 <div className="flex items-center justify-between">
 <span className="text-foreground">Without cache</span>
 <span className="text-foreground ">{formatCost(wouldHavePaid)}</span>
 </div>
 <div className="flex items-center justify-between">
 <span className="text-foreground">You paid</span>
 <span className="text-foreground ">{formatCost(totalCost)}</span>
 </div>
 <div className="flex items-center justify-between ">
 <span className="text-[var(--chart-1)]">Savings</span>
 <span className="text-[var(--chart-1)] ">{formatCost(totalSavings)}</span>
 </div>
 </div>
 </div>
 <ResponsiveContainer width="100%" height={140}>
 <PieChart>
 <Pie
 data={pieData}
 cx="50%"
 cy="50%"
 innerRadius={35}
 outerRadius={60}
 dataKey="value"
 strokeWidth={0}
 isAnimationActive={false}
 >
 {pieData.map((entry, i) => (
 <Cell key={i} fill={entry.color} />
 ))}
 </Pie>
 <Tooltip
 contentStyle={CHART_TOOLTIP_STYLE}
 formatter={(val, name) => [formatTokens(typeof val === 'number' ? val : 0), typeof name === 'string' ? name : '']}
 />
 </PieChart>
 </ResponsiveContainer>
 </div>
 )
}
